import {
  AbiRegistry,
  Address,
  SmartContract,
  SmartContractAbi,
} from '@multiversx/sdk-core/out';
import { NFT_LENDING_SC_ADDRESS, NFT_LENDING_SC_ABI_JSON, NFT_AMM_SC_ADDRESS, NFT_AMM_SC_ABI_JSON, JEWEL_LEND_V2_SC_ABI_JSON, JEWEL_LEND_V2_SC_ADDRESS, JEWEL_ASHSWAP_SC_ABI_JSON, JEWEL_ASHSWAP_SC_ADDRESS, ASHSWAP_FARM_SC_ABI_JSON } from 'config';

const abiRegistry = AbiRegistry.create(NFT_LENDING_SC_ABI_JSON);
const abi = new SmartContractAbi(abiRegistry);
export const nftLendingSmartContract = new SmartContract({
  address: new Address(NFT_LENDING_SC_ADDRESS),
  abi: abi,
});

const ammAbiRegistry = AbiRegistry.create(NFT_AMM_SC_ABI_JSON);
const ammAbi = new SmartContractAbi(ammAbiRegistry);
export const nftAmmSmartContract = new SmartContract({
  address: new Address(NFT_AMM_SC_ADDRESS),
  abi: ammAbi,
});

const jewelLendAbiRegistry = AbiRegistry.create(JEWEL_LEND_V2_SC_ABI_JSON);
const jewelLendAbi = new SmartContractAbi(jewelLendAbiRegistry);
export const jewelLendSmartContract = new SmartContract({
  address: new Address(JEWEL_LEND_V2_SC_ADDRESS),
  abi: jewelLendAbi,
});

const jewelFarmAbiRegistry = AbiRegistry.create(JEWEL_ASHSWAP_SC_ABI_JSON);
const jewelFarmAbi = new SmartContractAbi(jewelFarmAbiRegistry);
export const jewelUsdtAshFarmSmartContract = new SmartContract({
  address: new Address(JEWEL_ASHSWAP_SC_ADDRESS),
  abi: jewelFarmAbi,
});

export const farmAbiRegistry = AbiRegistry.create(ASHSWAP_FARM_SC_ABI_JSON);